import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDonut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle cx={10} cy={10} r={7.5} stroke="currentColor" strokeWidth={1.5} />
    <circle cx={10} cy={10} r={3.111} stroke="currentColor" strokeWidth={1.5} />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={0.5}
      d="M10 3v3.5m4.667 8.167-2.334-2.334m2.334-7-2.334 2.334M3 10h3.5"
    />
  </svg>
);
export default SvgDonut;
